import styled from 'styled-components';

export const getAspectRatio = (w, h) => {
  const aspectRatios = { width: 1, height: 1 };

  if (w < h) {
    aspectRatios.width = (w / h);
  }
  if (h < w) {
    aspectRatios.height = (h / w);
  }

  return aspectRatios;
};

const calculateWidth = ({ width, height, scale = 1 }) =>
  (getAspectRatio(width, height).width * scale * 100).toFixed(2);
const calculateHeight = ({ width, height, scale = 1 }) =>
  (getAspectRatio(width, height).height * scale * 100).toFixed(2);

const AspectRatio = styled.div`
position: relative;
width: ${calculateWidth}%;
padding-top: ${calculateHeight}%;
`;
export default AspectRatio;

